<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import { TokenDiamondIcon } from '@uiKit/icons'

// "No tokens yet" state for the token tab. Uses its own composition rather than
// the kit EmptyState because the design's mark is the token diamond in a soft
// orb, not EmptyState's PiIcon-in-orb or illustration.
defineEmits<{
  (e: 'browse'): void
}>()
</script>

<template>
  <Box direction="col" align="center" justify="center" gap="4" is="section" class="twe">
    <Box flex align="center" justify="center" class="twe__orb">
      <TokenDiamondIcon :size="34" />
    </Box>

    <Box direction="col" align="center" gap="2" class="twe__text">
      <Text type="title-lg" align="center" is="h2">No tokens yet</Text>
      <Text type="body" color="muted" align="center" is="p">
        You haven't invested in any properties yet. Once you purchase tokens, they'll appear here.
      </Text>
    </Box>
  </Box>
</template>

<style scoped>
.twe {
  background: var(--p-surface-0);
  border: 1px solid var(--p-content-border-color);
  border-radius: 16px;
  padding: 4rem 1.5rem;
  min-height: 420px;
  box-sizing: border-box;
}

.twe__orb {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--p-surface-100);
  flex-shrink: 0;
}

.twe__text {
  max-width: 460px;
}

@media (max-width: 992px) {
  .twe {
    padding: 3rem 1rem;
    min-height: 320px;
  }
}
</style>
